// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const DatePickerWrapper = styled.div<{ isDark: boolean; rtl?: boolean }>(
  ({ theme, isDark, rtl }) => css`
    .rdt {
      position: relative;
      font-family: 'Nunito';
      width: 100%;
      color: ${!isDark ? theme.colors.base.dark : theme.colors.white};
    }

    .rdtPicker {
      display: none;
      position: absolute;
      min-width: 270px;
      top: 70px;
      z-index: 99999 !important;
      background: ${
        isDark ? theme.colors.base['lighter-dark-mode'] : theme.colors.white
      };
      box-shadow: 0px 4px 18px rgba(92, 84, 122, 0.14);
      border-radius: 12px;
    }
    .rdtOpen .rdtPicker {
      display: block;
      ${
        rtl &&
        `
        right: 0;
      `
      }
    }
    .rdtStatic .rdtPicker {
      box-shadow: none;
      position: static;
    }

    .rdtPicker .rdtTimeToggle {
      text-align: center;
    }

    .rdtPicker table {
      width: 100%;
      margin: 0;
    }
    .rdtPicker td,
    .rdtPicker th {
      text-align: center;
      height: 28px;
      width: 28px;
      padding: 5px;
    }

    th {
      text-transform: capitalize;
    }

    .rdtPicker th:first-child {
      padding: 0 5px 0 10px;
    }

    .rdtPicker th:last-child {
      padding: 0 10px 0 5px;
    }

    .rdtPicker td {
      cursor: pointer;
    }

    .rdtDays > table {
      border-spacing: unset;
    }

    .rdtDays > table > thead {
      background: ${
        isDark
          ? theme.colors.base['light-dark-mode']
          : theme.colors.gray.lighter
      };
    }

    td.rdtDay:first-child {
      margin: 0 5px 0 20px;
    }

    td.rdtDay:last-child {
      margin: 0 20px 0 5px;
    }

    .rdtPicker td.rdtDay:hover,
    .rdtPicker td.rdtHour:hover,
    .rdtPicker td.rdtMinute:hover,
    .rdtPicker td.rdtSecond:hover,
    .rdtPicker .rdtTimeToggle:hover {
      background: ${
        isDark ? theme.colors.secondary.main : theme.colors.primary.main
      };
      color: ${isDark ? theme.colors.base.dark : theme.colors.white};
      border-radius: 50%;
      cursor: pointer;
    }
    .rdtPicker td.rdtOld,
    .rdtPicker td.rdtNew {
      color: ${theme.colors.gray.dark};
    }
    .rdtPicker td.rdtToday {
      position: relative;
    }
    .rdtPicker td.rdtToday:before {
      content: '';
      display: inline-block;
      border-left: 7px solid transparent;
      border-bottom: 7px solid ${theme.colors.red.main};
      border-top-color: rgba(0, 0, 0, 0.2);
      position: absolute;
      bottom: 4px;
      right: 4px;
    }
    .rdtPicker td.rdtActive,
    .rdtPicker td.rdtActive:hover {
      background-color: ${
        isDark ? theme.colors.secondary.main : theme.colors.primary.main
      };
      color: ${isDark ? theme.colors.base.dark : theme.colors.white};
      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
      border-radius: 50%;
    }

    td.rdtActive.rdtMonth,
    td.rdtActive.rdtYear,
    td.rdtActive.rdtMonth:hover,
    td.rdtActive.rdtYear:hover {
      background: ${
        isDark ? theme.colors.secondary.main : theme.colors.primary.main
      };
      color: ${isDark ? theme.colors.base.dark : theme.colors.white};
      border-radius: 0;
    }

    td.rdtMonth:hover,
    td.rdtYear:hover {
      background: ${
        isDark ? theme.colors.secondary.main : theme.colors.primary.main
      };
      color: ${isDark ? theme.colors.base.dark : theme.colors.white};
    }

    .rdtPicker td.rdtActive.rdtToday:before {
      border-bottom-color: ${theme.colors.white};
    }
    .rdtPicker td.rdtDisabled,
    .rdtPicker td.rdtDisabled:hover {
      background: none;
      color: ${theme.colors.gray.dark};
      cursor: not-allowed;
    }

    .rdtPicker td span.rdtOld {
      color: ${theme.colors.gray.dark};
    }
    .rdtPicker td span.rdtDisabled,
    .rdtPicker td span.rdtDisabled:hover {
      background: none;
      color: ${theme.colors.gray.dark};
      cursor: not-allowed;
    }

    .rdtPicker thead tr:last-child th {
      border-bottom: 1px solid
        ${isDark ? theme.colors.gray['main-dark-mode'] : theme.colors.gray.main};
    }
    .rdtPicker .dow {
      width: 14.2857%;
      border-bottom: none;
      cursor: default;
    }
    .rdtPicker th.rdtSwitch {
      width: 100px;
    }
    .rdtPicker th.rdtNext,
    .rdtPicker th.rdtPrev {
      font-size: 34px;
      vertical-align: top;
      color: ${
        isDark ? theme.colors.secondary.main : theme.colors.primary.main
      };
    }

    .rdtPicker th.rdtNext {
      border-radius: 0 12px 0 0;
    }

    .rdtPicker th.rdtPrev {
      border-radius: 12px 0 0 0;
    }

    .rdtPrev span,
    .rdtNext span {
      display: block;
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Chrome/Safari/Opera */
      -khtml-user-select: none; /* Konqueror */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
    }

    .rdtPicker th.rdtDisabled,
    .rdtPicker th.rdtDisabled:hover {
      background: none;
      color: ${theme.colors.gray.dark};
      cursor: not-allowed;
    }

    .rdtPicker thead tr:first-of-type th {
      cursor: pointer;
    }

    .rdtPicker tfoot {
      border-top: 1px solid
        ${isDark ? theme.colors.gray['main-dark-mode'] : theme.colors.gray.main};
    }

    .rdtPicker button {
      border: none;
      background: none;
      cursor: pointer;
    }

    .rdtPicker thead button {
      width: 100%;
      height: 100%;
    }

    td.rdtMonth,
    td.rdtYear {
      height: 50px;
      width: 25%;
      cursor: pointer;
    }

    .rdtCounters {
      display: inline-block;
    }

    .rdtCounters > div {
      float: left;
    }

    .rdtCounter {
      height: 100px;
    }

    .rdtCounter {
      width: 40px;
    }

    .rdtCounterSeparator {
      line-height: 100px;
    }

    .rdtCounter .rdtBtn {
      height: 40%;
      line-height: 40px;
      cursor: pointer;
      display: block;

      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Chrome/Safari/Opera */
      -khtml-user-select: none; /* Konqueror */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
    }

    .rdtCounter .rdtCount {
      height: 20%;
      font-size: 1.2em;
    }

    .rdtMilli {
      vertical-align: middle;
      padding-left: 8px;
      width: 48px;
    }

    .rdtMilli input {
      width: 100%;
      font-size: 1.2em;
      margin-top: 37px;
    }

    .rdtTime td {
      cursor: default;
    }

    .rdt {
      input {
        &::placeholder {
          color: ${isDark ? theme.colors.base.lighter : theme.colors.gray.dark};
        }
      }
    }
  `,
);
